var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.about) ? _c('div', {
    class: {
      'active': _vm.currentPage == _vm.page.about.$path
    },
    attrs: {
      "id": _vm.page.about.$path
    }
  }, [_c('div', {
    staticClass: "section section_about"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('Tabs', {
    attrs: {
      "content": [{
        text: _vm.page.about.company,
        comp: _vm.firstTab
      }, {
        text: _vm.page.about.strategy,
        comp: _vm.secondTab
      }, {
        text: _vm.page.about.investors,
        comp: _vm.thirdTab
      }, {
        text: _vm.page.about.whyelbruscapital,
        comp: _vm.fourthTab
      }]
    }
  })], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b38120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 191
// module chunks = 0